// extracted by mini-css-extract-plugin
module.exports = {"root":"template-badge_root__15Kl0","badge":"template-badge_badge__K8pOB","title":"template-badge_title__2aQMD"};